import{m as c}from"./chunk-HBP5N4FR.js";c();var s=(a=>(a.Address="Address",a.Balance="Balance",a.Hash="#",a))(s||{});export{s as a};
//# sourceMappingURL=chunk-STXBLUHN.js.map
